// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1G8ip","header":"ReportDetails_header__2mNMc","title":"ReportDetails_title__2XIdz","left":"ReportDetails_left__TYUFV"};